<template>
  <tr scope="row" class="border-t border-gray-200 font-normal dark:bg-gray-800">
    <slot></slot>
  </tr>
</template>
